<template>
    <div>
        <el-row :gutter="20">
            <carousel :perPageCustom="[[320, 1],[360, 2],[536, 3],[768, 3],[1024, 4], [1280, 4],[1440, 4],[1680, 4]]"
                :autoplay="doAutoplay" :autoplay-timeout="3000" :pagination-enabled="paginationEnabled"
                :pagination-active-color="paginationActiveColor" :pagination-color="paginationColor"
                :pagination-padding="paginationPadding" autoplayDirection="backward">
                <slide>
                    <router-link :to="{path: '/dashboard', query: { at: 'case' }}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/cases.svg'" alt="cases-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Cases')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <p class="digit">{{ this.countData.data['cases'] }}</p>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <slide>
                    <router-link :to="{path: '/dashboard', query: { at: 'patenkinder' }}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/paten.svg'" alt="contact-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Godchild')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data['patenkinder'] }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <!-- <slide>
                    <el-col class="access_user_count_box" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card class="box-card">
                            <div class="cards-left">
                                <img :src="'/static/card-icons/fachs.svg'" alt="fachstellen-image">
                            </div>
                            <div class="cards-right">
                                <p>
                                    <span class="card-head">{{$t('Access Users')}}</span>
                                    <span class="card-desc"></span>
                                </p>
                                <span class="digit">{{ this.countData.data['access_user'] }}</span>
                            </div>
                            <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                        </el-card>
                    </el-col>
                </slide> -->
                <slide>
                    <router-link :to="{path: '/dashboard', query: { at: 'contact' }}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/contacts.svg'" alt="spenders-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Contacts')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data.contact }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
            </carousel>
        </el-row>
        <section>
            <div class="grid-stack" data-gs-width="12" data-gs-height="0">
                <div class="grid-stack-item" data-gs-no-resize="yes"
                    data-gs-x="0" data-gs-y="0"
                    data-gs-width="5" data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Cases') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <monthly-case-status></monthly-case-status>
                        </div>
                    </div>
                </div>
                <div class="grid-stack-item" data-gs-no-resize="yes"
                    data-gs-x="5" data-gs-y="0"
                    data-gs-width="4" data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Recent Activities') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content recent-activities">
                            <div v-if="recentActivities.data.length > 0">
                                <el-card class="box-card" v-for="(activity) in recentActivities.data" :key="activity.id" >
                                    <div class="left-details">
                                        <p><span class="title-text">{{ $t('Name') }}:</span>
                                            {{ activity.name }}
                                        </p>
                                        <p><span class="title-text">{{ $t('What') }}:</span> <el-tag size="mini">{{ activity.model_name + ' ' + $options.filters.convertWordToPastTense(activity.action) }}</el-tag></p>
                                    </div>
                                    <div class="right-details">
                                        <p><span class="title-text">{{ $t('Date') }}:</span> <span v-date-time-format="activity.created_at"></span></p>
                                    </div>
                                </el-card>
                            </div>
                            <el-card v-else>
                                <div class="details">
                                    <p style="width: 100%; padding-bottom: 15px; text-align: center;">{{ $t('No activity found.') }}</p>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </div>
                <div class="grid-stack-item" data-gs-no-resize="yes"
                    data-gs-x="9" data-gs-y="0"
                    data-gs-width="3" data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Patenkinder') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content age-content">
                        <div class="grid-stack-item-content">
                            <age-wise-patenkinder />
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-stack" data-gs-width="12" data-gs-height="1" style="margin-top: 20px;">
                <div class="grid-stack-item" data-gs-no-resize="yes"
                    data-gs-x="0" data-gs-y="0"
                    data-gs-width="4" data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Notifications') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content recent-activities">
                            <div v-if="notifications.data.length > 0">
                                <el-card class="box-card" v-for="(notification) in notifications.data" :key="notification.id" >
                                    <router-link class="noti-left" :to="notification.notification_link">
                                        <p class="details">{{notification.notification_message}}</p>
                                        <span v-date-time-format="notification.created_at"></span>
                                    </router-link>
                                </el-card>
                            </div>
                            <el-card v-else>
                                <div class="details">
                                    <p style="width: 100%; padding-bottom: 15px; text-align: center;">{{ $t('No Notification found.') }}</p>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style lang="scss">
    .grid-stack {
        margin: 0 -10px;
    }
    .age-content .el-radio__label{
        font-size: 13px;
    }
    .age-content .el-radio {
        padding-left: 0;
        padding-right: 0;
    }
    @media screen and (max-width: 1024px) {
        .grid-stack {
            height: auto !important;
        }
        .grid-stack-item {
            position: relative!important;
            width: auto!important;
            left: 0!important;
            top: auto!important;
            margin-bottom: 20px;
        }
        .grid-stack-item {
            width: 100%!important;
        }
    }
</style>
<script>
    import Vue from 'vue';
    import VueCollapse from 'vue2-collapse';
    import gridstack from 'gridstack';
    Vue.use(VueCollapse);

    import {
        Carousel,
        Slide
    } from "vue-carousel";

    import MonthlyCaseStatus from "../Widgets/chart/components/MonthlyCaseStatus";
    import AgeWisePatenkinder from "../Widgets/Other/AgeWisePatenkinder";

    export default {
        components: {
            Carousel,
            Slide,
            MonthlyCaseStatus,
            AgeWisePatenkinder
        },
        data() {
            return {
                layout: [],
                countData: {
                    data: {}
                },
                recentActivities: {
                    data: {}
                },
                options: {
                    handle: '.drag',
                    animate: false,
                    cellHeight: 10,
                },
                doAutoplay: false,
                paginationEnabled: true,
                paginationActiveColor: 'var(--base-theme-color)',
                paginationColor: 'var(--table-theme-light-color)',
                paginationPadding: 5,
                notifications: {
                    meta: {},
                    data: {}
                },
            };
        },
        mounted() {
            setTimeout(() => {
                $('.grid-stack').gridstack(this.options);
            }, 500);
            this.getAllCount();
            this.getRecentActivities();
            this.getAllNotifications();
        },
        methods: {
            getAllCount() {
                request({
                    url: "dashboard-get-all-count",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.countData = response.data;
                });
            },
            getRecentActivities() {
                request({
                    url: "get-user-recent-activities",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.recentActivities = response.data;
                });
            },
            getAllNotifications() {
                request({
                    url: "user-notifications",
                    method: "get"
                })
                .then(response => {
                    this.notifications = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Layout/Fachstellen/DashboardTab.vue